import React, {Component} from 'react';
import {connect} from 'react-redux';
import Settings from './components/settings';
import Action from 'components/organisms/team-name-stacking/actions';
import TeamOptionsList from 'components/organisms/team-name-stacking/components/team-options-list';
import EnableSwitch from './enable-switch';

class TeamNameStacking extends Component {
    onClick(hidden) {
        this.props.dispatch(Action.set('TeamNameStackingWidgetIsHidden', !hidden));
    }
    render() {
        const {sportConfig, stacking} = this.props;

        if (!sportConfig.isReady()) {
            return null;
        }

        return (
            <div className={`advanced-filter${!stacking.isWidgetHidden() ? ' advanced-open' : ''}`}>
                <div className="advanced-top">
                    <button
                        type="button"
                        onClick={(e) => ::this.onClick(stacking.isWidgetHidden())}
                        className="btn-close-filter"
                    >
                        <i className="fa fa-times-circle"></i>Hide Settings
                    </button>
                    <button
                        type="button"
                        onClick={(e) => ::this.onClick(stacking.isWidgetHidden())}
                        className="advanced-opener"
                    >
                        <i className="fa fa-cog"></i>Per-Team Player Limits
                    </button>
                </div>
                <div className="white-box">
                    <div className="advanced-filter-heading">
                        <h3>Per-Team Player Limits</h3>
                        <EnableSwitch />
                    </div>
                    <Settings />
                    <TeamOptionsList />
                </div>
            </div>
        );
    }
}

function mapStatesToProps(state) {
    const {teamNameStacking, sportConfig} = state;

    return {
        sportConfig,
        stacking: teamNameStacking,
    };
}

export default connect(mapStatesToProps)(TeamNameStacking);
